import { InformalFeedbackRequestNotification } from '../../types'
import { BaseNotificationItem } from '../../BaseNotificationItem'
import { informalFeedbackRequestPath } from '../../utils'
import { iconForNotification } from './utils'

interface Props {
  notification: InformalFeedbackRequestNotification
  onClose: () => void
}

export const ReviewSubmittedNotification = (props: Props) => {
  const { notification } = props
  const isSuggestion = notification.subject.is_suggestion
  const type = notification.subject.submit_type
  const path = informalFeedbackRequestPath({ notification })

  const title = () => {
    if (notification.subject.is_mention) {
      return `mentioned you in their ${isSuggestion ? 'suggestion' : 'request'} feedback`
    }

    switch (type) {
      case 'approve':
        return 'approved this file'
      case 'reject':
        return 'sent back this file'
      case 'feedback':
      default:
        return 'left feedback in this file'
    }
  }

  return (
    <BaseNotificationItem
      {...props}
      title={title()}
      icon={iconForNotification(notification)}
      path={path}
      aria-label="Review Submitted Notification"
    />
  )
}
